import { ReactElement } from 'react';

import {
   CurrentHealthcareProviderPaymentsConfigurationQuery,
   CurrentHealthcareProviderPaymentsConfigurationRemoveCommand,
} from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { Translate } from '@dreryk/react-common';
import {
   dispatchSnackbarNegativeEvent,
   dispatchSnackbarPositiveEvent,
   Modal,
   ModalWidth,
} from '@dreryk/react-components';

import { onlinePaymentsProviderDetailsTranslationKeys } from '../../translations';

type OnlinePaymentsRemoveIntegrationModalProps = {
   readonly onCancel: VoidFunction;
};

export const OnlinePaymentsRemoveIntegrationModal = (
   props: OnlinePaymentsRemoveIntegrationModalProps
): ReactElement => {
   const { executeAsync: removeOnlinePaymentsConfiguration } = useCqrsCommand<void, void>(
      () => new CurrentHealthcareProviderPaymentsConfigurationRemoveCommand(),
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               onlinePaymentsProviderDetailsTranslationKeys.removeIntegrationModal.actions.removeConfiguration
                  .successMessage
            );
            refetchCqrsQuery(CurrentHealthcareProviderPaymentsConfigurationQuery);
         },
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(
               onlinePaymentsProviderDetailsTranslationKeys.removeIntegrationModal.actions.removeConfiguration
                  .failureMessage
            );
         },
      }
   );

   return (
      <Modal
         onConfirm={removeOnlinePaymentsConfiguration}
         testId={'onlinePaymentsRemoveIntegrationModal'}
         title={onlinePaymentsProviderDetailsTranslationKeys.removeIntegrationModal.title}
         width={ModalWidth.NORMAL}
         confirmationButtonLabel={
            onlinePaymentsProviderDetailsTranslationKeys.removeIntegrationModal.actions.removeConfiguration.buttonLabel
         }
         onCancel={props.onCancel}
      >
         <Translate>{onlinePaymentsProviderDetailsTranslationKeys.removeIntegrationModal.content}</Translate>
      </Modal>
   );
};
